module.exports = __webpack_public_path__ + "img/s1.abb5321a.jpg";